import React from "react";
import "./customLoading.css";

// Componente funcional sin props
const CustomLoading: React.FC = () => {
  // const Logo = () => {
  //  return LogoHeader === 'pepper' ? LogoPepper : LogoHeader === 'chop' ? LogoChop : ''
  // }

  return (
    <div className="CustomLogo">
      <div className="modal-bodyguard modal-bodyguard-light">
        <div className="art-modal wait-simple">
          <div className="loader">
            <span className="rotate"></span>
            {/* <span className="throb"></span> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomLoading;
